var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-section",class:{
    'c-section--transparent': _vm.isTransparent,
    'c-section--large-padding': _vm.largePadding,
    'c-section--overlay': _vm.overlay,
    'c-section--small-padding': _vm.smallPadding,
    'c-section--no-horizontal-padding': _vm.noHorizontalPadding,
    'c-section--no-vertical-padding': _vm.noVerticalPadding,
    'c-section--no-top-padding': _vm.noTopPadding,
    'c-section--no-bottom-padding': _vm.noBottomPadding,
    'c-section--poi': _vm.poiHeader,
    'c-section--borderless': _vm.borderless,
    'c-section--primary': _vm.primary
  }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }